"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VIEW_ONLY_PERMISSIONS = exports.YAHOO_AUTHOR_PERMISSIONS = exports.MANUAL_SENDER_PERMISSIONS = exports.Permission = void 0;
var Permission;
(function (Permission) {
    Permission["VIEW_DISTRIBUTION_REQUESTS"] = "VIEW_DISTRIBUTION_REQUESTS";
    Permission["VIEW_DEAD_LETTERS"] = "VIEW_DEAD_LETTERS";
    Permission["REINGEST_DEAD_LETTER"] = "REINGEST_DEAD_LETTER";
    Permission["VIEW_AUDIT_LOG"] = "VIEW_AUDIT_LOG";
    Permission["VIEW_VENDORS"] = "VIEW_VENDORS";
    Permission["VIEW_DISTRIBUTIONS"] = "VIEW_DISTRIBUTIONS";
    Permission["SEND_VENDOR_TEST_MESSAGE"] = "SEND_VENDOR_TEST_MESSAGE";
    Permission["VIEW_QUEUE"] = "VIEW_QUEUE";
    Permission["VIEW_COMPANIES"] = "VIEW_COMPANIES";
    Permission["VIEW_SETTINGS"] = "VIEW_SETTINGS";
    Permission["EDIT_SETTINGS"] = "EDIT_SETTINGS";
    Permission["RESYNC_COMPANIES"] = "RESYNC_COMPANIES";
    Permission["MANUAL_RETRY_TRANSMISSION"] = "MANUAL_RETRY_TRANSMISSION";
    Permission["TOGGLE_VENDOR_ACTIVE"] = "TOGGLE_VENDOR_ACTIVE";
    Permission["CONFIRM_COMPANY_RECALL"] = "CONFIRM_COMPANY_RECALL";
    Permission["SEND_MANUAL_DISTRIBUTION"] = "SEND_MANUAL_DISTRIBUTION";
    // Write Yahoo!ファイナンス articles (Yahoo記事); viewing them needs only VIEW_DISTRIBUTIONS.
    Permission["EDIT_YAHOO_ARTICLES"] = "EDIT_YAHOO_ARTICLES";
})(Permission || (exports.Permission = Permission = {}));
// What an account on MANUAL_SENDER_EMAILS (and not an admin) gets on top of view-only.
exports.MANUAL_SENDER_PERMISSIONS = [Permission.SEND_MANUAL_DISTRIBUTION];
// What an account on YAHOO_AUTHOR_EMAILS (and not an admin) gets on top of view-only.
exports.YAHOO_AUTHOR_PERMISSIONS = [Permission.EDIT_YAHOO_ARTICLES];
// What a signed-in account outside ADMIN_EMAILS gets: every screen, no action.
exports.VIEW_ONLY_PERMISSIONS = [
    Permission.VIEW_DISTRIBUTION_REQUESTS,
    Permission.VIEW_DEAD_LETTERS,
    Permission.VIEW_AUDIT_LOG,
    Permission.VIEW_VENDORS,
    Permission.VIEW_DISTRIBUTIONS,
    Permission.VIEW_QUEUE,
    Permission.VIEW_COMPANIES,
    Permission.VIEW_SETTINGS,
];
